var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.initialized,
          expression: "initialized"
        }
      ]
    },
    [
      _c("div", { staticClass: "hearing-aid-sales__filters" }, [
        _c(
          "div",
          { staticClass: "filter-sales-dates__report filter-selection" },
          [
            _c("div", { staticClass: "filter-selection__title" }, [
              _vm._v("Report:")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-selection__body" },
              [
                _c("StoreConnectedSelect", {
                  staticClass: "filter-selection__select",
                  attrs: {
                    store: _vm.store,
                    action: "setReport",
                    name: _vm.name,
                    "sub-prop": "flashReportName",
                    placeholder: "Reports",
                    options: _vm.reportsList,
                    "options-label": "name",
                    "options-value": "name"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "filter-products__vendor filter-selection" }, [
          _c("div", { staticClass: "filter-selection__title" }, [
            _vm._v("Vendor:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-selection__body" },
            [
              _c("StoreConnectedSelect", {
                staticClass: "filter-selection__select",
                attrs: {
                  store: _vm.store,
                  action: _vm.action,
                  name: _vm.name,
                  "sub-prop": "vendor",
                  placeholder: "Vendors",
                  options: _vm.vendorsList,
                  multiple: "",
                  "clear-button": ""
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-products__tier filter-selection" }, [
          _c("div", { staticClass: "filter-selection__title" }, [
            _vm._v("Tier:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-selection__body" },
            [
              _c("StoreConnectedSelect", {
                staticClass: "filter-selection__select",
                attrs: {
                  store: _vm.store,
                  action: _vm.action,
                  name: _vm.name,
                  "sub-prop": "tier",
                  placeholder: "Tiers",
                  options: _vm.tiersList,
                  multiple: "",
                  "clear-button": ""
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-products__promo filter-selection" }, [
          _c("div", { staticClass: "filter-selection__title" }, [
            _vm._v("Promo:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-selection__body" },
            [
              _c("StoreConnectedSelect", {
                staticClass: "filter-selection__select",
                attrs: {
                  store: _vm.store,
                  action: _vm.action,
                  name: _vm.name,
                  "sub-prop": "promo",
                  placeholder: "Promos",
                  options: _vm.promosList,
                  multiple: "",
                  "clear-button": ""
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "hearing-aid-sales__commands" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-primary hearing-aid-sales__btn-run",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.update($event)
                  }
                }
              },
              [_vm._v("Run Report")]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }